export function getActiveSheet() {
  return window.o_global.pali.sheet?.getActiveSheet();
}
